import { ThunkAction } from "redux-thunk";

import { api, isAxiosError } from "src/common/utils/api";
import { confirmSignOut } from "src/features/auth/session";
import { User } from "src/features/auth/types";

export type AuthAction =
	| InitializeStart
	| InitializeSuccess
	| InitializeFailure
	| KeepAliveStart
	| KeepAliveSuccess
	| KeepAliveFailure
	| UpdateUser;

interface InitializeStart {
	type: "INITIALIZE_START";
}

interface InitializeSuccess {
	type: "INITIALIZE_SUCCESS";
	payload: { user: User };
}

interface InitializeFailure {
	type: "INITIALIZE_FAILURE";
	payload: { error: unknown };
}

interface UpdateUser {
	type: "UPDATE_USER";
	payload: { user: Partial<User> };
}

interface KeepAliveStart {
	type: "KEEP_ALIVE_START";
}

interface KeepAliveSuccess {
	type: "KEEP_ALIVE_SUCCESS";
}

interface KeepAliveFailure {
	type: "KEEP_ALIVE_FAILURE";
	payload: { error: unknown };
}

export function initialize(): ThunkAction<
	Promise<void>,
	unknown,
	void,
	AuthAction
> {
	return async dispatch => {
		dispatch({ type: "INITIALIZE_START" });
		try {
			const { data } = await api.get<User>("/initialize");
			dispatch({ type: "INITIALIZE_SUCCESS", payload: { user: data } });
		} catch (error) {
			dispatch({ type: "INITIALIZE_FAILURE", payload: { error } });
			redirectToSignIn();
		}
	};
}

export function keepAlive(): ThunkAction<
	Promise<void>,
	unknown,
	void,
	AuthAction
> {
	return async dispatch => {
		dispatch({ type: "KEEP_ALIVE_START" });
		try {
			await api.get("/keepalive");
			dispatch({ type: "KEEP_ALIVE_SUCCESS" });
		} catch (error) {
			if (isAxiosError(error) && error.response?.status === 403) {
				dispatch({
					type: "KEEP_ALIVE_FAILURE",
					payload: { error }
				});
				confirmSignOut();
			}
		}
	};
}

export function updateUser(user: Partial<User>): AuthAction {
	return { type: "UPDATE_USER", payload: { user } };
}

function redirectToSignIn(): void {
	if (location.pathname === "/") {
		window.location.href = "/sign-in";
	} else {
		window.location.href = `/sign-in?return-to=${encodeURI(location.href)}`;
	}
}
